// Cuộn ảo theo dòng cố định: chỉ dựng các dòng đang trong khung nhìn (+ đệm).
export interface VirtualWindow {
  start: number;
  end: number;
  padTop: number;
  padBottom: number;
}

export function virtualWindow(total: number, rowH: number, scrollTop: number, viewH: number, overscan = 6): VirtualWindow {
  const start = Math.max(0, Math.min(total, Math.floor(scrollTop / rowH) - overscan));
  const end = Math.min(total, Math.ceil((scrollTop + viewH) / rowH) + overscan);
  return { start, end, padTop: start * rowH, padBottom: Math.max(0, (total - end) * rowH) };
}
